import { type UserCountByTypeConstructor } from '../../entities/UserCountByType'
import { type UserCountByTypeApiModel } from '../api-models/UserCountByTypeApiModel'

export const mapUserCountByTypeApiModel = (
  userCount: UserCountByTypeApiModel
): UserCountByTypeConstructor => ({
  proUsers: userCount.pro_users,
  basicUsers: userCount.basic_users,
  totalUsers: userCount.total_users,
  maxProUsers: userCount.max_pro_users,
})
